
import ContractAdd from './Add.vue'
import ContractEdit from './Edit.vue'

export default [
  {
    path: 'add',
    name: 'ContractAdd',
    props: true,
    component: ContractAdd
  },
  {
    path: 'edit',
    name: 'ContractEdit',
    props: true,
    component: ContractEdit
  }
]
